
/*
   const subscriptionKey = process.env.REACT_APP_SPEECH_KEY;
   const serviceRegion = process.env.REACT_APP_SPEECH_REGION;
*/


/***********************SDK***************************** */


// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import * as speechSDK from 'microsoft-cognitiveservices-speech-sdk';

// const TextToSpeech = () => {
//   const [text, setText] = useState('');
//   const [audioUrl, setAudioUrl] = useState('');
//   const [voices, setVoices] = useState([]);
//   const [selectedVoice, setSelectedVoice] = useState('');
//   const [isSpeaking, setIsSpeaking] = useState(false);
//   const synthesizerRef = useRef(null);
//   const audioRef = useRef(null);

//   const subscriptionKey = process.env.REACT_APP_SPEECH_KEY;
//   const region = process.env.REACT_APP_SPEECH_REGION;

//   console.log({ voices });

//   // Memoize the speechConfig to prevent it from being recreated on every render
//   const speechConfig = useMemo(() => {
//     return speechSDK.SpeechConfig.fromSubscription(subscriptionKey, region);
//   }, [subscriptionKey, region]);

//   useEffect(() => {
//     const fetchVoices = async () => {
//       const synthesizer = new speechSDK.SpeechSynthesizer(speechConfig);
//       const result = await synthesizer.getVoicesAsync();

//       if (result.reason === speechSDK.ResultReason.VoicesListRetrieved) {
//         setVoices(result.voices);
//         setSelectedVoice(result.voices[0].shortName); // Set default voice
//       } else {
//         console.error('Error retrieving voices: ' + result.errorDetails);
//       }
//       synthesizer.close();
//     };

//     fetchVoices();
//   }, [speechConfig]);

//   const handleConvertTextToSpeech = async () => {
//     // Close any ongoing speech synthesis
//     if (synthesizerRef.current) {
//       synthesizerRef.current.close();
//       synthesizerRef.current = null;
//     }

//     // Pause and clear the current audio
//     if (audioRef.current) {
//       audioRef.current.pause();
//       audioRef.current.src = ''; // Clear the current audio source
//     }

//     // Create a new synthesizer
//     speechConfig.speechSynthesisVoiceName = selectedVoice;
//     const synthesizer = new speechSDK.SpeechSynthesizer(speechConfig);
//     synthesizerRef.current = synthesizer; // Store synthesizer in ref

//     setIsSpeaking(true);

//     synthesizer.speakTextAsync(
//       text,
//       result => {
//         if (result.reason === speechSDK.ResultReason.SynthesizingAudioCompleted) {
//           const audioBlob = new Blob([result.audioData], { type: 'audio/wav' });
//           const url = URL.createObjectURL(audioBlob);
//           setAudioUrl(url);
//           if (audioRef.current) {
//             audioRef.current.src = url;
//             audioRef.current.play();
//             synthesizer.close();
//           }
//         } else {
//           console.error('Error synthesizing speech: ' + result.errorDetails);
//         }
//         synthesizer.close();
//         synthesizerRef.current = null; // Clear synthesizer ref
//         setIsSpeaking(false);
//       },
//       error => {
//         console.error('Error synthesizing speech: ' + error);
//         synthesizer.close();
//         synthesizerRef.current = null; // Clear synthesizer ref
//         setIsSpeaking(false);
//       }
//     );
//   };

//   const handlePlay = () => {
//     audioRef.current.play();
//   };

//   const handlePause = () => {
//     audioRef.current.pause();
//   };

//   const handleSeek = (event) => {
//     audioRef.current.currentTime = event.target.value;
//   };

//   return (
//     <div>
//       <h1>Text to Speech</h1>
//       <textarea
//         value={text}
//         onChange={(e) => setText(e.target.value)}
//         placeholder="Enter text here"
//       ></textarea>
//       <br />
//       <select
//         value={selectedVoice}
//         onChange={(e) => setSelectedVoice(e.target.value)}
//         disabled={isSpeaking}
//       >
//         {voices.map((voice) => (
//           <option key={voice.shortName} value={voice.shortName}>
//             {voice.displayName} ({voice.privLocaleName}) ({voice?.gender === 1 ? 'Female' : 'Male'})
//           </option>
//         ))}
//       </select>
//       <br />
//       <button onClick={handleConvertTextToSpeech} disabled={isSpeaking}>
//         {isSpeaking ? 'Converting...' : 'Convert to Speech'}
//       </button>
//       <br /><br />
//       {audioUrl && (
//         <div>
//           <audio ref={audioRef} controls></audio>
//           <br />
//           <button onClick={handlePlay}>Play</button>
//           <button onClick={handlePause}>Pause</button>
//           <input
//             type="range"
//             min="0"
//             max={audioRef.current ? audioRef.current.duration : 0}
//             step="0.01"
//             onChange={handleSeek}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default TextToSpeech;

/*************************** RESTful API ********************************* */

import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { escapeForSSML, removeHtmlTags } from '../../../../../utils/commonServices';

const TextToSpeech = () => {
 // const [text, setText] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState('');
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1.0); // Default playback rate
  const audioRef = useRef(null);
  const contentReducer = useSelector((state) => state.contentReducer)

  const subscriptionKey = process.env.REACT_APP_SPEECH_KEY;
  const region = process.env.REACT_APP_SPEECH_REGION;

  useEffect(() => {
    const fetchVoices = async () => {
      try {
        const response = await fetch(`https://${region}.tts.speech.microsoft.com/cognitiveservices/voices/list`, {
          headers: {
            'Ocp-Apim-Subscription-Key': subscriptionKey
          }
        });
        const data = await response.json();
        setVoices(data);
        setSelectedVoice(data[0].ShortName);
      } catch (error) {
        console.error('Error fetching voices:', error);
      }
    };
   // console.log("before api text", contentReducer?.editor_text)
    fetchVoices();
  }, [region, subscriptionKey]);

  const handleConvertTextToSpeech = async () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = ''; // Clear the current audio source
    }

    setIsSpeaking(true);

    try {
      
      const response = await fetch(`https://${region}.tts.speech.microsoft.com/cognitiveservices/v1`, {
        method: 'POST',
        headers: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
          'Content-Type': 'application/ssml+xml',
          'X-Microsoft-OutputFormat': 'audio-48khz-192kbitrate-mono-mp3'
        },
        body: `
          <speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xml:lang='en-US'>
            <voice name='${selectedVoice}'>
              ${escapeForSSML(removeHtmlTags(contentReducer?.editor_text))}
            </voice>
          </speak>`
      });

      if (!response.ok) {
        throw new Error(`Error synthesizing speech: ${response.statusText}`);
      }

      const audioBlob = await response.blob();
      const url = URL.createObjectURL(audioBlob);
      setAudioUrl(url);
    } catch (error) {
      console.error('Error synthesizing speech:', error);
    }

    setIsSpeaking(false);
  };

  useEffect(() => {
    if (audioUrl && audioRef.current) {
      audioRef.current.src = audioUrl;
      audioRef.current.play();
    }
  }, [audioUrl]);

  const handlePlay = () => {
    audioRef.current.play();
  };

  const handlePause = () => {
    audioRef.current.pause();
  };

  const handleSeek = (event) => {
    audioRef.current.currentTime = event.target.value;
  };

  const handlePlaybackRateChange = (event) => {
    const rate = parseFloat(event.target.value);
    setPlaybackRate(rate);
    if (audioRef.current) {
      audioRef.current.playbackRate = rate;
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = audioUrl;
    link.download = 'speech.wav';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

 

  return (
    <div>
      {/* <h1>Text to Speech</h1>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter text here"
      ></textarea>
      <br /> */}
      <select
        value={selectedVoice}
        onChange={(e) => setSelectedVoice(e.target.value)}
        disabled={isSpeaking}
      >
        {voices.map((voice) => (
          <option key={voice.ShortName} value={voice.ShortName}>
            {voice.DisplayName} ({voice.Locale}) ({voice.Gender === 'Female' ? 'Female' : 'Male'})
          </option>
        ))}
      </select>
      <br />
      <button onClick={handleConvertTextToSpeech} disabled={isSpeaking}>
        {isSpeaking ? 'Converting...' : 'Convert to Speech'}
      </button>
      <br /><br />
      {audioUrl && (
        <div>
         
          <audio ref={audioRef}  controls></audio>
          {/* <br />
          <button onClick={handlePlay}>Play</button>
          <button onClick={handlePause}>Pause</button>
          <input
            type="range"
            min="0"
            max={audioRef.current ? audioRef.current.duration : 0}
            step="0.01"
            onChange={handleSeek}
          />
          <br /> */}
          <button onClick={handleDownload}>Download</button>
          <br />
          <label htmlFor="playbackRate">Playback Speed:</label>
          <select
            id="playbackRate"
            value={playbackRate}
            onChange={handlePlaybackRateChange}
          >
            <option value="0.5">0.5x</option>
            <option value="1">1x</option>
            <option value="1.5">1.5x</option>
            <option value="2">2x</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default TextToSpeech;



